/**
 * AdminLayout — админ-панель: центрированное меню; бургер с ≤1500px.
 */

import React, { useCallback, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AdminMenu from "../menus/AdminMenu";

const AdminLayout = ({ children }) => {
    const { pathname } = useLocation();
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    const isApplicationsSection =
        pathname === "/acp" ||
        pathname === "/acp/" ||
        pathname.startsWith("/acp/check-characters");

    const isNewsSection = pathname.startsWith("/acp/news");
    const isLogsSection = pathname.startsWith("/acp/logs");

    return (
        <div className="app-container app-container--admin">
            <div className="main-container">
                <header className="admin-header">
                    <div className="admin-header-left">
                        <button
                            type="button"
                            className="burger-button admin-burger-button"
                            onClick={() => openBurgerFn && openBurgerFn()}
                            aria-label="Меню"
                        >
                            <div></div>
                        </button>
                        <AdminMenu onTrigger={handleSetOpenBurger} />
                    </div>

                    <nav className="admin-header-links" aria-label="Админ-меню">
                        <Link to="/acp/check-characters">
                            <span
                                className={`admin-header-link ${isApplicationsSection ? "active" : ""}`}
                            >
                                ПРОВЕРКА ЗАЯВОК
                            </span>
                        </Link>
                        <span className="admin-header-link admin-header-link--muted">
                            АДМИНИСТРАТОРЫ
                        </span>
                        <span className="admin-header-link admin-header-link--muted">
                            ВЫДАЧА
                        </span>
                        <span className="admin-header-link admin-header-link--muted">
                            БЛОКИРОВКИ
                        </span>
                        <Link to="/acp/news">
                            <span
                                className={`admin-header-link ${isNewsSection ? "active" : ""}`}
                            >
                                НОВОСТИ
                            </span>
                        </Link>
                        <Link to="/acp/logs">
                            <span
                                className={`admin-header-link ${isLogsSection ? "active" : ""}`}
                            >
                                ЛОГИ
                            </span>
                        </Link>
                        <Link to="/ucp">
                            <span className="admin-header-link">ВЫХОД</span>
                        </Link>
                    </nav>
                </header>

                <main>{children}</main>
            </div>
        </div>
    );
};

export default AdminLayout;
